$(document).ready(function () {
  $(".footer__show").click(function () {
    $(this).toggleClass("footer__show_active");
    $(".footer__menu_less, .footer__menu_more").slideToggle();
  });

  // GOUP
  $.goup({
    // containerColor: "#bababa",
    containerSize: 60,
    containerRadius: 30,
    location: "left",
    zIndex: 25,
    hideUnderWidth: 0,
  });

  if (localStorage.getItem("cookie_showed") !== String(1)) {
    setTimeout(() => {
      var cookieInfo = document.getElementById("cookie-info");

      if (cookieInfo) {
        cookieInfo.style.display = "block";

        document
          .getElementById("cookie-info-btn")
          .addEventListener("click", () => {
            cookieInfo.style.display = "none";
            localStorage.setItem("cookie_showed", 1);
          });
      }
    }, 2000);
  }

  var $lossyWebp = false;
  var $stickySidebar = null;

  check_webp_feature("lossy", (feature, result) => ($lossyWebp = result));

  if ($("#sticky-sidebar").length) {
    $stickySidebar = new StickySidebar("#sticky-sidebar", {
      topSpacing: 180,
    });
  }

  const infNext = document.querySelector(".inf-next");

  if (infNext !== null) {
    const infContainer = document.querySelector(".pagination__container"),
      infMore = document.querySelector(".inf-more"),
      infMoreContainer = infMore.parentElement,
      infStatus = document.querySelector(".inf-status"),
      infPages = document.querySelector(".inf-pages");

    infScroll = new InfiniteScroll(infContainer, {
      path: ".inf-next",
      append: ".pagination__item",
      status: infStatus,
      button: infMore,
      loadOnScroll: false,
      fetchOptions: () => ({
        headers: {
          Accept: "*/*" + ($lossyWebp ? ", image/webp" : ""),
          "X-Requested-With": "XMLHttpRequest",
        },
      }),
    });

    if (infScroll.canLoad) {
      infMoreContainer.style.display = "block";
    }

    // infScroll.once("load", onceLoad);
    infScroll.on("request", onRequest);
    infScroll.on("load", onLoad);
    infScroll.on("last", onLast);
    infScroll.on("append", onAppend);

    // function onceLoad() {
    //   if (infScroll.loadCount == 1 && infScroll.canLoad) {
    //     infScroll.options.loadOnScroll = false;
    //     infMore.style.display = "inline-block";
    //   }
    // }

    function onRequest() {
      infMoreContainer.style.display = "none";

      if ($stickySidebar) {
        $stickySidebar.updateSticky();
      }
    }

    function onAppend() {
      checkLazy();

      if ($stickySidebar) {
        $stickySidebar.updateSticky();
      }
    }

    function onLoad(body) {
      if (infScroll.canLoad) {
        infMoreContainer.style.display = "block";
      }

      if (infPages !== null) {
        const p = body.querySelector(".inf-pages");

        if (p !== null) {
          infPages.innerHTML = p.innerHTML;
        } else {
          infPages.style.display = "block";
        }
      }
    }

    function onLast() {
      infMore.style.display = null;
    }
  }

  // replaceSvg();
  checkLazy();
  initFilter();
  initCarousel();

  var showingmenusection;

  // $("#left_menu_clone").hide();

  if ($("#fullpage").length) {
    $(window)
      .on("resize scroll", () => onscroll())
      .scroll();

    // } else {
    //   if (!mobile) {
    //     $(".footer").appendTo(".page-leftbar");
    //     $(".footer").css("position", "absolute");
    //     $(".footer__tel").hide();
    //     $(".footer").css("width", "100%");

    //     $(".main-leftbar").appendTo("#header");
    //     $("#left_menu_clone").show();
    //   }
  }

  $("#btn-mobile-menu").click(function () {
    $("#footer").toggleClass("footer_show");
    $(this).children().toggleClass("hide");
  });

  $(".categories-ul button").on("click", function () {
    var $li = $(this).closest("li");
    $li.find("ul").slideToggle();
    $li.find("button").toggleClass("open");
  });

  // $(window).on("scroll.infow", () => {
  //   if ($(window).scrollTop() > 0) {
  //     $("#infow").hide();
  //     $(window).off("scroll.infow");
  //   }
  // });

  // $(window).on("resize scroll", function () {
  //   if ($(".d-lg-none").is(":hidden")) {
  //     var m = false;
  //   } else {
  //     var m = true;
  //   }

  //   if (mobile != m) {
  //     location.reload();
  //   }
  // });

  function onscroll() {
    if ($(".d-lg-none").is(":hidden")) {
      $(".page-leftbar-wrap").each(function () {
        $(this).hide();
      });

      var sectionsWeights = [];

      $(".section").each(function () {
        $(this).ifInViewport(sectionsWeights);
      });

      sectionsWeights.sort(function (a, b) {
        return a.bottom - b.bottom;
      });

      var menusection = sectionsWeights[0].obj
        .children(".page-row")
        .children(".page-leftbar")
        .children(".page-leftbar-wrap");

      if (!menusection.is(showingmenusection)) {
        showingmenusection = menusection; //.clone(true, true);
        // $("#left_menu_clone").hide();
        // $("#left_menu_clone").html(showingmenusection.html());
        // $("#left_menu_clone").show();

        $("#left_menu_clone").fadeOut(200, function () {
          $("#left_menu_clone")
            .html(showingmenusection.html())
            .fadeIn(200, function () {
              // replaceSvg();
              checkLazy();
              initFilter();
            });
        });
      }
    }
  }

  $(".product__image-wrapper").lightGallery({ selector: ".product__image" });

  if (document.getElementById("checkout")) {
    formPrepare($("form#checkout"));
  }

  formPrepare($("#form-feedback"));

  const bodyClass = document.body.className;
  // console.log(document.body.className);

  if (bodyClass.indexOf("common-home") !== -1) {
    initCommonHome();
  } else if (bodyClass.indexOf("product-product") !== -1) {
    initProductProduct();
  } else if (bodyClass.indexOf("product-category") !== -1) {
    initProductCategory();
  } else if (bodyClass.indexOf("product-search") !== -1) {
    initProductSearch();
  } else if (bodyClass.indexOf("rmx-objects") !== -1) {
    initRmxObjects();
  } else if (bodyClass.indexOf("rmx-about") !== -1) {
    initRmxAbout();
  } else if (bodyClass.indexOf("checkout-checkout") !== -1) {
    initCheckoutCheckout();
  } else if (bodyClass.indexOf("harsika-account-history") !== -1) {
    initHarsikaAccountHistory();
  } else if (bodyClass.indexOf("account-register") !== -1) {
    pageAccountRegister();
  } else if (bodyClass.indexOf("account-edit") !== -1) {
    pageAccountEdit();
  }
});

$.fn.ifInViewport = function (sectionsWeights) {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  if (elementBottom > viewportTop && elementTop < viewportBottom) {
    if (elementBottom > (viewportBottom - viewportTop) / 2 + viewportTop) {
      let wp = { obj: this, bottom: elementBottom };
      sectionsWeights.push(wp);
    }
  }
};
